export default __webpack_public_path__ + "static/media/sk_logo_crop.5fd9b785.png";